export const PERMISSIONS = {
    CLIENT: 1,
    COACH: 2,
    ADMIN: 3,
};